// import React, {useEffect, useState} from 'react';
// import {View, Animated, ScrollView, StyleSheet} from 'react-native';

// import {Text, Button, InputLabel, CustomerPicker} from 'components';

// import css from 'styles';
// import {mq} from 'utils';
// import {colors, sizes, strings} from 'assets/constants';

// import SelectedFiltersView from './SelectedFiltersView';

// export interface NotesFiltersT {
//   customer?: PickerItemT;
// }

// export default function Filters(props: {
//   translate: Animated.AnimatedInterpolation<string | number>;
//   initials: NotesFiltersT;
//   cancel?: () => void;
//   apply?: (newFilters: NotesFiltersT) => void;
// }) {
//   const {initials, cancel, apply, translate} = props;

//   const [innerFilters, setInnerFilter] = useState(initials);

//   useEffect(() => setInnerFilter(initials), [initials]);

//   const _onApply = () => apply && apply(innerFilters);
//   const _onCancel = () => {
//     setInnerFilter(initials);
//     cancel && cancel();
//   };

//   return (
//     <Animated.View
//       style={{
//         ...css.absoluteFitContent,
//         backgroundColor: colors.screensBg,
//         transform: [{translateX: translate}],
//       }}>
//       <View
//         style={{
//           height: mq(48),
//           ...css.paddingH,
//           ...css.rowCenterAlign,
//           marginTop: sizes.space,
//           marginBottom: sizes.space * 0.3,
//         }}>
//         <Button onPress={_onCancel} square={mq(40)} icon={{name: 'x'}} />
//         <View style={css.container} />
//         <Text weight="bold" size={'xxl'}>
//           {strings.filters}
//         </Text>
//       </View>

//       <View style={{height: mq(30), top: mq(-8)}}>
//         <SelectedFiltersView filters={innerFilters} onChange={setInnerFilter} />
//       </View>

//       <ScrollView
//         contentContainerStyle={{
//           ...css.growContainer,
//           ...css.paddingH,
//           top: mq(-8),
//         }}
//         showsVerticalScrollIndicator={false}>
//         <InputLabel label={strings.customer} />
//         <CustomerPicker
//           value={innerFilters.customer}
//           onSelect={customer => setInnerFilter({...innerFilters, customer})}
//         />
//       </ScrollView>
//       <View style={styles.footer}>
//         <Button
//           onPress={_onApply}
//           width={mq(120)}
//           labelColor={colors.white}
//           label={strings.apply_filters}
//           style={{marginRight: sizes.space}}
//         />

//         <Button
//           outline
//           onPress={_onCancel}
//           width={mq(100)}
//           label={strings.cancel}
//         />
//       </View>
//     </Animated.View>
//   );
// }

// const styles = StyleSheet.create({
//   footer: {
//     bottom: mq(0),
//     width: '100%',
//     padding: sizes.space,
//     ...css.rowCenterAlign,
//     position: 'absolute',
//     borderTopLeftRadius: mq(20),
//     borderTopRightRadius: mq(20),
//     backgroundColor: '#f1f1f1',
//   },
// });

import React, { useEffect, useState } from "react";
import { View } from "react-native";

import {
  Input,
  Picker,
  InputLabel,
  CityPicker,
  DatePicker,
  CustomerPicker,
} from "components";
import FiltersTemplate from "screens/components/FiltersTemplate";

import { strings } from "assets/constants";
import { filtersItems } from "assets/data";
import css from "styles";

import { useCustomerStatus } from "clients/apis";

export interface NotesFiltersT {
  customer?: PickerItemT;
}

export default function Filters(props: {
  visible: boolean;
  hide?: () => void;
  initials: NotesFiltersT;
  apply?: (newFilters: NotesFiltersT) => void;
}) {
  const { data: customerStatus } = useCustomerStatus();

  const { initials, hide, apply, visible } = props;

  const [innerFilters, setInnerFilters] = useState(initials);

  useEffect(() => setInnerFilters(initials), [initials]);

  const _onApply = () => apply && apply(innerFilters);
  const _onCancel = () => {
    setInnerFilters(initials);
    hide && hide();
  };

  return (
    <FiltersTemplate
      filtersItems={filtersItems.notes}
      innerFilters={innerFilters}
      setInnerFilters={setInnerFilters}
      visible={visible}
      _onApply={_onApply}
      _onCancel={_onCancel}
    >
      <>
        <InputLabel label={strings.customer} />
        <CustomerPicker
          value={innerFilters.customer}
          onSelect={(customer) =>
            setInnerFilters({ ...innerFilters, customer })
          }
        />
      </>
    </FiltersTemplate>
  );
}
